import React from 'react';
import { Banknote, Landmark, CreditCard } from 'lucide-react';

interface PaymentMethodViewProps {
  cart: any[];
  customer: any;
  deliveryOption: string;
  onBack: () => void;
  onPaymentMethodSelected: (method: string) => void;
}

function PaymentMethodView({ cart, customer, deliveryOption, onBack, onPaymentMethodSelected }: PaymentMethodViewProps) {
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <div className="payment-view">
      <div className="payment-header">
        <button className="btn-secondary" onClick={onBack}>
          ← Atrás
        </button>
        <h1>Método de Pago</h1>
        <div className="cart-summary-mini">
          <span>{totalItems} artículos</span>
          <span>${totalPrice.toFixed(2)}</span>
        </div>
      </div>

      <div className="payment-content">
        <div className="order-summary">
          <h3>Resumen del pedido:</h3>
          <div className="order-details">
            <p><strong>Cliente:</strong> {customer.name}</p>
            <p><strong>Entrega:</strong> {deliveryOption}</p>
          </div>
        </div>

        <div className="payment-options">
          <h3>Selecciona el método de pago:</h3>

          <div className="payment-option" onClick={() => onPaymentMethodSelected('Efectivo')}>
            <div className="payment-option-icon">
              <Banknote size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Efectivo</h4>
              <p>Pago en efectivo</p>
              <span className="payment-status">Método: Efectivo</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>

          <div className="payment-option" onClick={() => onPaymentMethodSelected('Transferencia')}>
            <div className="payment-option-icon">
              <Landmark size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Transferencia</h4>
              <p>Transferencia bancaria</p>
              <span className="payment-status">Método: Transferencia</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>

          <div className="payment-option" onClick={() => onPaymentMethodSelected('Tarjeta')}>
            <div className="payment-option-icon">
              <CreditCard size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Tarjeta</h4>
              <p>Pago con tarjeta</p>
              <span className="payment-status">Método: Tarjeta</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentMethodView;
